import React from "react";
import SuggestItem from "./SuggestItem";
import css from "../AutoSamplete.module.css";

function Suggestions({ results, getSpecificContract, setTextInput }) {
  return (
    <div className={css.SuggestMainDiv}>
      {results.map(el => (
        <SuggestItem
          getSpecificContract={getSpecificContract}
          key={el.contract_id}
          result={el}
          {...el}
          setTextInput={setTextInput}
        />
      ))}
    </div>
  );
}
export default Suggestions;
